import { AdsProvider } from './ads-provider';
import { DemoProvider } from './demo-provider';
import { EditorialProvider } from './editorial-provider';
import { FallbackProvider } from './fallback-provider';
import { LocalDevProvider } from './local-dev-provider';
import { PlusProvider } from './plus-provider';

/**
 * A lot of directions we can be taken to determine a provider.
 * All the logic is defined in order or preference.
 */
export function determineWallpaperProvider(config, state) {
  // 0. Something went wrong. Let's show the fallback.
  if (FallbackProvider.test(config, state)) return FallbackProvider;

  // 1. Local development wallpapers are enabled and set.
  if (LocalDevProvider.test(config, state)) return LocalDevProvider;

  // 2. This is used by sales to preview wallpapers accessing /wallpaper/:advert_id
  if (DemoProvider.test(config, state)) return DemoProvider;

  // 3. We're on a channel. Show user's background if available
  if (PlusProvider.test(config, state)) return PlusProvider;

  // 4. Adblocker has been detected, or we are in a channel with no wallpapers.
  if (EditorialProvider.test(config, state)) {
    return EditorialProvider;
  }

  // 5. Serve advertisement
  return AdsProvider;
}
